import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import * as React from 'react';

import { useApplicationContext } from 'shared/containers/ApplicationContext';

import { TPlace } from '../types';

export function useMicrofrontEvents(
  manifest: IMicrofrontendManifest | undefined,
  lastLoadingPlaceRef: React.RefObject<TPlace | null>,
  loadingPlaceSetter: (type: TPlace | null) => void,
) {
  const { eventQueue } = useApplicationContext();

  const handleInitialLoadingStart = React.useCallback(
    () => loadingPlaceSetter(lastLoadingPlaceRef.current),
    [lastLoadingPlaceRef, loadingPlaceSetter],
  );
  const handleInitialLoadingEnd = React.useCallback(() => {
    loadingPlaceSetter(null);
  }, [loadingPlaceSetter]);

  React.useEffect(() => {
    if (!manifest) {
      return;
    }

    eventQueue.on(
      'newbuilding-broker-modals-micro-frontend-reporting.v1.self-request-modal-initial-loading::start',
      handleInitialLoadingStart,
    );

    return () =>
      eventQueue.off(
        'newbuilding-broker-modals-micro-frontend-reporting.v1.self-request-modal-initial-loading::start',
        handleInitialLoadingStart,
      );
  }, [eventQueue, handleInitialLoadingStart, manifest]);

  React.useEffect(() => {
    if (!manifest) {
      return;
    }

    eventQueue.on(
      'newbuilding-broker-modals-micro-frontend-reporting.v1.self-request-modal-initial-loading::end',
      handleInitialLoadingEnd,
    );

    return () =>
      eventQueue.off(
        'newbuilding-broker-modals-micro-frontend-reporting.v1.self-request-modal-initial-loading::end',
        handleInitialLoadingEnd,
      );
  }, [eventQueue, handleInitialLoadingEnd, manifest]);
}
